import React, {Component} from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import app from '../base/api';

class BasicSelect extends Component {

  constructor (props) {
    super(props)
    this.state = {value: '', values: []}
  }

  async componentDidMount ()  {
    if (this.props.relation) {
      let res = await app.get(`/api/tables/${this.props.relation}`);
      if (res) {
        let list = [];
        for (let record of res) {
          list.push({value: record.id, label: record.Nombre})
        }
        this.setState({values: list})
      }
    }
  }

  handleChange = (event) => {
    this.setState({value: event.target.value});
    this.props.onChange({target: {value: event.target.value, id: this.props.id}})
  };

  render () {
    var rows = [];
    if (this.props.values) {
      for (let value of this.props.values) {
        rows.push(<MenuItem  key={value} value={value}>{value}</MenuItem>)
      }
    } else if (this.props.relation) {
      for (let v of this.state.values) {
        rows.push(<MenuItem  key={v.value} value={v.value}>{v.label}</MenuItem>)
      }
    }
    return (
    <Box sx={{ minWidth: 120 }} className="multi-select-react">
      <FormControl fullWidth >
        <InputLabel id="demo-simple-select-label">{this.props.label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          disabled={this.props.disabled}
          value={this.props.value}
          label={this.props.label}
          onChange={this.handleChange}
        >
            {rows}
        </Select>
      </FormControl>
    </Box>
    );
  }
}

export default BasicSelect;
